import "./dashboard.css";
import $ from "jquery";
import notAllowed from './notAllowed.png'
import gears1 from './gears_1.png'
import gears from './gears.png'
import InputBar from "../InputBar/InputBar";
import React from "react";

function MindaDashboard(props) {
  return (
    <>
      <div className="box box-default">
        <div className="box-header">

          <InputBar InsIden={"mindaDashboard"}
                    machineType={true}
                    line={true}
                    machine={true}
                    shift={true}
                    shiftDate={true}/>
          
        </div>
        <div className="box-body">
          <div id="noMachine" className="row justify-content-center">
            <div className="col-12 col-md-3 text-center">
              <img src={gears} alt="Gears" />
            </div>
          </div>
          <div id="machineData" className="hide">
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  <table
                    id="resourceAllocationTableData"
                    className="table table-striped table-bordered dataTable no-footer"
                  >
                    <thead>
                      <tr>
                        <th>Work Order</th>
                        <th>Tool</th>
                        <th>Part No.</th>
                        <th>Part Name</th>
                        <th>Parts (Planned)</th>
                        <th>Parts (Produced)</th>
                        <th>Date</th>
                        <th>Planned Duration</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1</td>
                        <td>XYZ1</td>
                        <td>K_1204</td>
                        <td>K_1204</td>
                        <td>24</td>
                        <td>0</td>
                        <td>17:30:00</td>
                        <td>01:20:00</td>
                        <td>2022-01-24 08:35:22</td>
                        <td>&nbsp;</td>
                        <td>
                          <label className="btn btn-sm btn-warning">
                            Planned
                          </label>
                        </td>
                        <td>
                          <a
                            href="#"
                            className="btn btn-sm btn-success"
                            data-toggle="modal"
                            data-target="#jobStart"
                          >
                            Start
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>XYZ2</td>
                        <td>K_1205</td>
                        <td>K_1205</td>
                        <td>24</td>
                        <td>20</td>
                        <td>17:30:00</td>
                        <td>01:20:00</td>
                        <td>2022-01-24 08:35:22</td>
                        <td>2022-01-24 08:35:22</td>
                        <td>
                          <label className="btn btn-sm btn-danger">
                            Suspended
                          </label>
                        </td>
                        <td>
                          <a
                            href="#"
                            className="btn btn-sm btn-success"
                            data-toggle="modal"
                            data-target="#jobStart"
                          >
                            Resume
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>3</td>
                        <td>XYZ3</td>
                        <td>K_1206</td>
                        <td>K_1206</td>
                        <td>24</td>
                        <td>0</td>
                        <td>17:30:00</td>
                        <td>01:20:00</td>
                        <td>2022-01-24 08:35:22</td>
                        <td>&nbsp;</td>
                        <td>
                          <label className="btn btn-sm btn-warning">
                            Planned
                          </label>
                        </td>
                        <td>
                          <a
                            href="#"
                            className="btn btn-sm btn-success"
                            data-toggle="modal"
                            data-target="#jobStart"
                          >
                            Start
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>4</td>
                        <td>XYZ4</td>
                        <td>K_1207</td>
                        <td>K_1207</td>
                        <td>24</td>
                        <td>0</td>
                        <td>17:30:00</td>
                        <td>01:20:00</td>
                        <td>2022-01-24 08:35:22</td>
                        <td>&nbsp;</td>
                        <td>
                          <label className="btn btn-sm btn-warning">
                            Planned
                          </label>
                        </td>
                        <td>
                          <a
                            href="#"
                            className="btn btn-sm btn-success"
                            data-toggle="modal"
                            data-target="#jobStart"
                          >
                            Start
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <td>5</td>
                        <td>XYZ5</td>
                        <td>K_1208</td>
                        <td>K_1208</td>
                        <td>24</td>
                        <td>24</td>
                        <td>17:30:00</td>
                        <td>01:20:00</td>
                        <td>2022-01-24 08:35:22</td>
                        <td>2022-01-24 08:35:22</td>
                        <td>
                          <label className="btn btn-sm btn-primary">
                            Completed
                          </label>
                        </td>
                        <td>&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="info-box">
                  <span className="info-box-icon bg-default">
                    <i className="fa fa-list"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Planned Quantity</span>
                    <span className="info-box-number">500</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="info-box">
                  <span className="info-box-icon bg-success">
                    <i className="fa fa-cubes"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">
                      Ideal Production Quantity
                    </span>
                    <span className="info-box-number">520</span>
                  </div>
                </div>
              </div>
              <div className="clearfix visible-sm-block"></div>
              <div className="col-lg-4 col-md-6">
                <div className="info-box">
                  <span className="info-box-icon bg-primary">
                    <i className="fa fa-cube"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Actual Production</span>
                    <span className="info-box-number">485</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="info-box">
                  <span className="info-box-icon bg-danger">
                    <i className="fa fa-ban"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Defects</span>
                    <span className="info-box-number">20</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="info-box">
                  <span className="info-box-icon bg-success">
                    <i className="fa fa-clock-o"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Total Time (Minutes)</span>
                    <span className="info-box-number">52:02:07</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="info-box">
                  <span className="info-box-icon bg-danger">
                    <i className="fa fa-clock-o"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Downtime (Minutes)</span>
                    <span className="info-box-number">00:21:33</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="info-box">
                  <span className="info-box-icon bg-warning">
                    <i className="fa fa-percent"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Shift OEE</span>
                    <span className="info-box-number">87%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="notAllowed" className="row justify-content-center hide">
            <div className="col-12 col-md-3 text-center">
              <img src={notAllowed} alt="not allowed" />
            </div>
          </div>
        </div>
      </div>
      <div className="modal" id="jobStart">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Start Work</h4>
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div className="modal-body">
              <h5 className="text-center">Do you want to start this job ?</h5>
              <br />
              <p className="text-center">
                <img src={gears1} className="machinePart" alt="machine part" />
              </p>
            </div>
            <div className="modal-footer">
              <div className="row form-group">
                <div className="col-12">
                  <button className="btn btn-default" data-dismiss="modal">
                    Cancel
                  </button>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <a href="operatorDashboard.html" className="btn btn-primary">
                    Yes
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MindaDashboard;

$("#machineId").change(function () {
  var $machineId = $(this).val();
  if ($machineId !== "0") {
    if ($machineId === "1") {
      $("#machineData").removeclassName("hide");
      $("#noMachine").addclassName("hide");
      $("#notAllowed").addclassName("hide");
    } else {
      if ($("#noMachine").hasclassName("hide") !== true) {
        $("#noMachine").addclassName("hide");
      }
      if ($("#machineData").hasclassName("hide") !== true) {
        $("#machineData").addclassName("hide");
      }
      if ($("#notAllowed").hasclassName("hide") === true) {
        $("#notAllowed").removeclassName("hide");
      }
    }
  } else {
    $("#noMachine").removeclassName("hide");
    if ($("#machineData").hasclassName("hide") !== true) {
      $("#machineData").addclassName("hide");
    }
    if ($("#notAllowed").hasclassName("hide") !== true) {
      $("#notAllowed").addclassName("hide");
    }
  }
});
